<template>
    <span>{{ paymentModeLabel }}</span>
</template>

<script>
export default {
    name: "IncOrderPaymentMode",
    props: {
        paymentMode: {
            type: String,
            default: null
        },
        paymentPreference: {
            type: String,
            default: null
        },
        orderType: {
            type: String,
            default: null
        }
    },
    computed: {
        paymentModeLabel() {
            if (this.paymentMode === 'STRIPE_CARTACREDITO') {
                return this.$t('carrello_pag_carte');
            }

            switch (this.paymentPreference) {
                case 'CONTANTI':
                    return this.$t('contanti');
                case 'CARTA_CREDITO':
                    if (this.orderType === 'DELIVERY' || this.orderType === 'DIL') {
                        return this.$t('carta_di_credito_consegna');
                    }
                    return this.$t('carta_di_credito_ritiro');
                case 'BUONI_PASTO':
                    return this.$t('carrello_pag_buoni_pasto');
                default:
                    return this.$t('contanti');
            }
        }
    }
}
</script>
